import React, { useContext } from "react";
import SelectionItem from "../../SelectionItem";
import ImgEsTypVeneers from "./images/imgEsTypVeneers.png";
import ImgEsTypCrowns from "./images/imgEsTypCrowns.png";
import ImgEsTypRestorations from "./images/imgEsTypRestorations.png";
import "./index.scss";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const EsteticTypicalSelectRestorations = ({
  selectStep
}) => {
  const {
    _t
  } = useTranslation();
  const {
    dentalData,
    toggleBottomBarInfo
  } = useContext(StepContext);
  const types = [{
    key: "esTypicalVeneers",
    img: ImgEsTypVeneers,
    name: _t("Виниры"),
    description: _t("Виниры – тонкие пластинки из керамики, которые фиксируются на передней части зуба и по цвету не отличаются от эмали..."),
    aboutKey: "esVeneersSelection"
  }, {
    key: "esTypicalCrowns",
    img: ImgEsTypCrowns,
    name: _t("Коронки"),
    description: _t("Коронки - это несъемные зубные протезы, которые фиксируются на обточенные зубы для восстановления их формы и цвета..."),
    aboutKey: "esCrownsSelection"
  }, {
    key: "esTypicalRestorations",
    img: ImgEsTypRestorations,
    name: _t("Композитные реставрации"),
    description: _t("Композитные реставрации - это поэтапное наслоение фотополимерного материала на зубы для восстановления их формы и цвета..."),
    aboutKey: "esRestorationsSelection"
  }];

  function setStep(key) {
    let updatedData = {};

    switch (key) {
      case "esTypicalVeneers":
        updatedData = {
          tooth: [...dentalData.tooth.map(item => {
            return { ...item,
              toothElementsActive: item.toothElementsActive.includes("healthyTooth") ? ["veneerTab"] : item.toothElementsActive
            };
          })]
        };
        break;

      case "esTypicalCrowns":
        updatedData = {
          tooth: [...dentalData.tooth.map(item => {
            return { ...item,
              toothElementsActive: item.toothElementsActive.includes("healthyTooth") ? ["plasticCrown"] : item.toothElementsActive
            };
          })]
        };
        break;

      case "esTypicalRestorations":
        updatedData = {
          tooth: [...dentalData.tooth.map(item => {
            return { ...item,
              toothElementsActive: item.toothElementsActive.includes("healthyTooth") ? ["oldEsteticTooth", "newEsteticTooth"] : item.toothElementsActive
            };
          })]
        };
        break;

      default:
        break;
    }

    selectStep(`${key}_finishStep`, updatedData);
  }

  function openBottomBar(type) {
    toggleBottomBarInfo(true, type);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "esteticTypicalSelectRestorations"
  }, /*#__PURE__*/React.createElement("div", {
    className: "esteticTypicalSelectRestorations-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    itemKey: el.aboutKey,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    outerTitle: el.name,
    outerDescription: el.description,
    aboutClick: () => openBottomBar(el.aboutKey)
  }))));
};

export default EsteticTypicalSelectRestorations;